import React, { bindActionCreators } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactModal from "react-modal";
import { List, Map } from "immutable";

import { getRoute, setCurrentPage } from "data/voting-form/routes";

import { setCampaign as selectParentCampaign } from "data/parent-campaign";

import DonateForm from "./DonateForm";
import SearchInCategory from "./SearchInCategory";
import SelectParentCampaign from "./SelectParentCampaign";
import Finish from "./Finish";
import ThankYou from "./ThankYou";
import Vote from "./Vote";

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    overflowX: "hidden",
    overflowY: "auto",
    zIndex: 2000,
  },
  content: {
    position: "relative",
    height: "100%",
    top: "initial",
    bottom: "initial",
    left: "initial",
    right: "initial",
    padding: 0,
    border: "initial",
    background: "initial",
    WebkitOverflowScrolling: "touch",
    outline: "none",
  },
};

class VotingModal extends React.Component {
  handleCloseModal = () => {
    const { closeModal, resetAll } = this.props;

    closeModal();
  };

  componentWillReceiveProps(nextProps) {
    const { isModalOpen, preSelectCampaignToVoteFor } = this.props;
    const { selectParentCampaign, setCurrentPage } = this.props;

    // redirect if open and we want to preselect the campaign and its the first page
    if (
      nextProps.isModalOpen &&
      nextProps.currentRoute === "select-parent-campaign" &&
      preSelectCampaignToVoteFor &&
      !this.hasSkippedStep
    ) {
      selectParentCampaign(preSelectCampaignToVoteFor);
      setCurrentPage("donate");

      // don't keep trying to skip the step
      this.hasSkippedStep = true;
    } else if (!nextProps.isModalOpen) {
      this.hasSkippedStep = false;
    }
  }

  renderRoute() {
    const { entity, currentRoute } = this.props;

    if (currentRoute == "select-parent-campaign") {
      return <SelectParentCampaign onCloseModal={this.handleCloseModal} />;
    } else if (currentRoute === "thank-you") {
      return <ThankYou onCloseModal={this.handleCloseModal} />;
    } else if (currentRoute === "vote") {
      return <Vote onCloseModal={this.handleCloseModal} />;
    } else if (currentRoute === "finish") {
      return <Finish entity={entity} onCloseModal={this.handleCloseModal} />;
    }

    return <DonateForm onCloseModal={this.handleCloseModal} />;
  }
  render() {
    const { isModalOpen } = this.props;

    if (!isModalOpen) {
      return null;
    }

    return (
      <ReactModal
        contentLabel="Voting donation form"
        isOpen={isModalOpen}
        style={customStyles}>
        {this.renderRoute()}
      </ReactModal>
    );
  }
}

VotingModal.propTypes = {
  entityId: PropTypes.string.isRequired,
  currentRoute: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  campaign: PropTypes.instanceOf(Map).isRequired,

  closeModal: PropTypes.func.isRequired,
  selectParentCampaign: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    currentRoute: getRoute(state),
  };
};

const mapDispatchToProps = {
  setCurrentPage,
  selectParentCampaign,
};

export default connect(mapStateToProps, mapDispatchToProps)(VotingModal);
